module.exports = __webpack_public_path__ + "static/img/icon-en-1.e2486e43.png";